import { StrapiVendor } from './strapi-vendor.model';

export type ShippingType = 'product' | 'flatrate' | 'freeShipping' | 'sendcloud';

export const SHIPPING_TYPES = {
  PRODUCT: 'product' as ShippingType,
  FLATRATE: 'flatrate' as ShippingType,
  FREE_SHIPPING: 'freeShipping' as ShippingType,
  SENDCLOUD: 'sendcloud' as ShippingType
};

export interface StrapiShippingRate {
  id: number;
  title?: string;
  rate: number;
  vendor: StrapiVendor;
  isDefault: boolean;
  shippingType?: ShippingType;
  minOrderAmount?: number;
  hasAssociatedProducts?: boolean;
}
